module.exports = __webpack_public_path__ + "static/media/Firma manuscrita.b85f1821.svg";